import styled from 'styled-components';
import { Colors, Breakpoints } from 'styles/Constants';
import BaseBox from 'components/boxes/BaseBox';

export const GridWrapper = styled.div`
  ${BaseBox};

  display: grid;
  grid-template-columns: 200px 10fr 2fr;
  gap: 20px;
  align-items: center;
  background: ${Colors.normalWhite};
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 15px;
  box-shadow: 0 1px 6px 0 rgb(79 79 79 / 38%);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px 0 rgb(79 79 79 / 25%);
  }

  .content-img {
    width: 150px;
    height: 150px;
    min-height: inherit !important;
    display: flex !important;
    align-items: center !important;
  }

  img {
    width: 100%;
    height: inherit;
    object-fit: contain;
  }

  .time-line {
    margin: 0 0 5px 0;
    font-weight: 500;
    line-height: 1.5;
    font-size: 14px;
    color: ${Colors.primaryNormalPurple};
    text-transform: capitalize;
  }

  .social-networks {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }

  .format {
    margin-left: 15px;
  }

  .subtitle {
    margin-right: 5px;
    font-weight: bold;
  }

  @media only screen and (max-width: 900px) {
    width: 120%;
  }

  @media (max-width: ${Breakpoints.medium}) {
    display: none;
  }
`;

export const MarginText = styled.div`
  padding: 5px;
  font-weight: 500;
  font-size: 14px;
  overflow: hidden;

  &.m-auto {
    margin: auto 0px;
  }

  div {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    h2 {
      font-weight: bold;
      position: relative;
      font-size: 18px;
      margin: 0;
    }
  }

  @media (max-width: ${Breakpoints.medium}) {
    &.m-auto {
      .time-line {
        font-size: 11px;
      }

      h2 {
        font-size: 16px;
      }
    }
  }
`;

export const DivIcon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  img {
    width: 25px;
    margin: 5px;
  }
`;

export const DivIconChallenge = styled.div`
  display: flex;
  zoom: 80%;

  img {
    width: 50px;
  }
`;

export const Card = styled.div`
  margin: 0 5px 5px;

  p {
    width: auto;
    height: 80px;
  }
`;

export const EmptyCard = styled.div`
  margin: 0 10px 10px;
  width: 100%;
`;

export const MarginImg = styled.div`
  img {
    width: 80%;
    display: block;
    margin: 0px auto;
    min-width: 350px;
    min-height: 350px;
    max-width: 350px;
    max-height: 350px;
    object-fit: contain;
  }
`;

// ===== NUEVOS ESTILOS RESPONSIVE PARA MOBILE =====

export const MobileCard = styled.div`
  display: none;

  @media (max-width: ${Breakpoints.medium}) {
    display: block;
    padding: 16px;
    margin-bottom: 16px;
    background: ${Colors.normalWhite};
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 15px;
    box-shadow: 0 1px 6px 0 rgb(79 79 79 / 38%);
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }
`;

export const MobileContent = styled.div`
  .mobile-header {
    display: flex;
    align-items: center;
    margin-bottom: 12px;

    .mobile-image {
      width: 100px;
      height: 100px;
      border-radius: 8px;
      object-fit: cover;
      margin-right: 12px;
      flex-shrink: 0;
    }

    .mobile-title-section {
      flex: 1;

      .mobile-time-line {
        font-size: 12px;
        color: ${Colors.secondaryText};
        margin: 0 0 6px 0;
        font-weight: 500;
        text-transform: capitalize;
      }

      .mobile-title {
        font-size: 16px;
        font-weight: 600;
        color: ${Colors.primaryText};
        margin: 0;
        line-height: 1.3;
      }
      .mobile-social-section {
        margin-top: 10px;
        .mobile-subtitle {
          font-weight: 600;
          color: ${Colors.primaryText};
          font-size: 14px;
          display: block;
          margin-bottom: 8px;
          margin-right: 5px;
        }

        .mobile-social-icons {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
        }
      }
    }
  }

  .mobile-details {
    text-align: center;
    .mobile-rules,
    .mobile-format {
      margin-bottom: 12px;

      .mobile-subtitle {
        font-weight: 600;
        color: ${Colors.primaryText};
        font-size: 14px;
        margin-right: 5px;
      }

      .mobile-text {
        font-size: 14px;
        color: ${Colors.secondaryText};
        line-height: 1.4;
      }
    }
  }
`;

export const MobileActions = styled.div`
  margin-top: 16px;
  padding-top: 16px;

  .mobile-button {
    width: 100%;
    justify-content: center;
  }
`;
